import { render, staticRenderFns } from "./NewsMediaIndex.vue?vue&type=template&id=0cbd30c3&lang=pug"
import script from "./NewsMediaIndex.vue?vue&type=script&lang=js"
export * from "./NewsMediaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports